import { TextField } from "@mui/material"

export const UnitPrice = ({ params }) => {
    return (
        <TextField
            type="text"
            variant='standard'
            className='w-full mb-5 px-0 pt-0'
            value={params.value}
            disabled
        />
    )
}
